import cn from 'classnames';
import { Column } from '@odin-labs/components';
import { WorkerComment } from 'apollo/generated/client-operations';
import { ObjectHistory } from 'components/objectHistory';
import { ObjectHistoryFormat } from 'components/objectHistory/types';
import React from 'react';

export type WorkerCommentColumn = Column<WorkerComment>;

export const getColumns = (): WorkerCommentColumn[] => [
  {
    id: 'comment',
    Header: 'Comment',
    cellClassName: cn('odin-whitespace-pre-line odin-py-2'),
    accessor: 'comment',
  },
  {
    id: 'jobsite',
    Header: 'Jobsite',
    accessor: (comment: WorkerComment): string => comment?.jobsite?.name,
  },
  {
    id: 'createdBy',
    Header: 'Created By',
    accessor: (comment: WorkerComment): WorkerComment => comment,
    Cell: ({ value }: { value: WorkerComment }): React.ReactElement => (
      <ObjectHistory object={value} format={ObjectHistoryFormat.Name} />
    ),
  },
  {
    id: 'createdAt',
    Header: 'Date',
    accessor: (comment: WorkerComment): WorkerComment => comment,
    Cell: ({ value }: { value: WorkerComment }): React.ReactElement => (
      <ObjectHistory object={value} format={ObjectHistoryFormat.Time} />
    ),
  },
];
